/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Intro, Controls, ControlGroup } from "components/containers";
import { Description, Title } from "components/typography";
import { Section, Wrapper } from "../styles";
import { fetchVideoAssets } from "redux/actions/mktassets";
import AffiliateData from "utils/user-data";
import { ExportButton } from "components/buttons";
import VideoAssetsTable from "components/tables/video-assets";
import MainSelect from "components/main-select";

const VideoA = () => {
  const dispatch = useDispatch();
  const loggedInAff = new AffiliateData();

  const { campaigns } = useSelector((state) => state.aff_campaigns);

  const options =
    campaigns === null
      ? []
      : campaigns.map((el) => ({ label: el.name, value: el.id }));

  useEffect(() => {
    dispatch(
      fetchVideoAssets(
        {
          domain: loggedInAff.get().data.affiliate.domain,
          affId: loggedInAff.get().data.affiliate.id,
        },
        {}
      )
    );
  }, []);

  return (
    <Section>
      <Intro>
        <Title>Video assets</Title>
        <Description>
          These videos have been provided to aid your content marketing. You can
          upload them to your streaming platforms and embed them on your blog or
          website.
        </Description>
      </Intro>
      <Wrapper>
        <Controls
          style={{
            padding: "1em",
            borderTopLeftRadius: 10,
            borderTopRightRadius: 10,
          }}
        >
          {/* <ExportButton caption="Export Report" /> */}
          <ControlGroup>
            <MainSelect label={null} options={options} />
          </ControlGroup>
        </Controls>
        <VideoAssetsTable />
      </Wrapper>
    </Section>
  );
};

export default VideoA;
